<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import Select from '$components/Form/Select.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const projectTypeOptions = [
        `Résidentiel`,
        `Commercial`,
        `Industriel`,
        `Éclairage public`,
        `Électrification rurale`,
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const servicesOptions = [
        `Installation électrique`,
        `Maintenance`,
        `Fourniture de matériel`,
        `Mise en conformité`,
        `Solutions d'énergie renouvelable`,
        `Groupe électrogène`,
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const productRequirementsOptions = [
        `Oui (veuillez préciser)`,
        `Non`,
        `Ouvert aux suggestions`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.electricien.projectType}
        class=""
        let:field
        let:id
        label={`Quel type de projet électrique envisagez-vous ?`}
    >
        <Select
            {form}
            {field}
            {id}
            required={false}
            options={projectTypeOptions}
            placeholder="Sélectionnez un type de projet"
        />
    </Row>

    <Row
        {form}
        field={fields.electricien.services}
        class=""
        let:field
        let:id
        label={`Quels services recherchez-vous principalement ?`}
    >
        <Select
            {form}
            {field}
            {id}
            required={false}
            options={servicesOptions}
            placeholder="Sélectionnez un service"
        />
    </Row>

    <Row
        {form}
        field={fields.electricien.productRequirements}
        class=""
        let:field
        let:id
        label={`Avez-vous des exigences spécifiques en matière de produits ou de marques ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-3 gap-x-6 gap-y-1"
            choices={productRequirementsOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
